import { createSlice, current } from '@reduxjs/toolkit';
export const customQueryHeader = createSlice({
  name: 'dataType',
  initialState: {
    buttonsNamesArray: [{
      name: 'Users',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Groups',
        isSelected: false
      }, {
        name: 'Roles',
        isSelected: false
      }, {
        name: 'Permissions',
        isSelected: false
      }, {
        name: 'Resources',
        isSelected: false
      }]
    }, {
      name: 'User Accounts',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Groups',
        isSelected: false
      }, {
        name: 'Roles',
        isSelected: false
      }, {
        name: 'Permissions',
        isSelected: false
      }, {
        name: 'Resources',
        isSelected: false
      }]
    }, {
      name: 'Groups',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Users',
        isSelected: false,
        disabledIfSelected: 'User Accounts'
      }, {
        name: 'User Accounts',
        isSelected: false,
        disabledIfSelected: 'Users'
      }, {
        name: 'Permissions',
        isSelected: false
      }, {
        name: 'Resources',
        isSelected: false
      }]
    }, {
      name: 'Roles',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Users',
        isSelected: false,
        disabledIfSelected: 'User Accounts'
      }, {
        name: 'User Accounts',
        isSelected: false,
        disabledIfSelected: 'Users'
      }, {
        name: 'Permissions',
        isSelected: false
      }, {
        name: 'Resources',
        isSelected: false
      }]
    }, {
      name: 'Permissions',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Users',
        isSelected: false,
        disabledIfSelected: 'User Accounts'
      }, {
        name: 'User Accounts',
        isSelected: false,
        disabledIfSelected: 'Users'
      }, {
        name: 'Groups',
        isSelected: false
      }, {
        name: 'Roles',
        isSelected: false
      }, {
        name: 'Resources',
        isSelected: false
      }]
    }, {
      name: 'Resources',
      variant: 'outlined',
      relatedEntity: [{
        name: 'Users',
        isSelected: false,
        disabledIfSelected: 'User Accounts'
      }, {
        name: 'User Accounts',
        isSelected: false,
        disabledIfSelected: 'Users'
      }, {
        name: 'Groups',
        isSelected: false
      }, {
        name: 'Roles',
        isSelected: false
      }, {
        name: 'Permissions',
        isSelected: false
      }]
    }],
    selectedDataType: '',
    enableCriteria: false,
    apiResponse: [],
    showRelatedData: false,
    enableClearAll: false,
    relatedData: [],
    relatedDataButton: [],
    hideCard: false,
    apiResponseData: [],
    showDialogWin: false,
    downloadCSVResults: false,
    relationTableData: {
      data: [],
      totalCount: 0,
      totalPages: 0
    },
    snackEnable: false,
    isSaveDisabled: true,
    queryRelatedEntity: [],
    runSelected: false,
    buttonName: '',
    showPath: false,
    showSnackLoader: false,
    isLoader: false,
    showConfirmationWin: false,
    isNavigating: false,
    isSaveAsPopUp: false,
    isBritSave: false,
    isEntityChanged: false,
    isRelatedEntityChanged: false
  },
  reducers: {
    pushAddCriteria: (state, action) => {
      state.enableCriteria = action.payload;
    },
    pushIsSaveAsPopUp: (state, action) => {
      state.isSaveAsPopUp = action.payload;
    },
    pushShowRelatedDta: (state, action) => {
      state.showRelatedData = action.payload;
    },
    pushIsNavigating: (state, action) => {
      state.isNavigating = action.payload;
    },
    pushHideCard: (state, action) => {
      state.hideCard = action.payload;
    },
    showContextualPath: (state, action) => {
      state.showPath = action.payload;
    },
    selectedRelatedEntity: (state, action) => {
      let prevRelatedData = current(state.relatedData);
      state.relatedData = action.payload;
      let currentRelatedData = state.relatedData;

      for (let i = 0; i < prevRelatedData.length; i++) {
        if (prevRelatedData.length > 0 && currentRelatedData.length === 0 || prevRelatedData[i].isSelected !== currentRelatedData[i].isAlreadySelected) {
          state.isRelatedEntityChanged = true;
          break;
        }
      }
    },
    selectedRelatedDataButton: (state, action) => {
      state.relatedDataButton = action.payload;
      state.enableCriteria = state.relatedDataButton.length > 0;
    },
    selectButton: (state, action) => {
      let {
        selectedName
      } = action.payload;
      let currentButtons = current(state.buttonsNamesArray);
      let allButtons = currentButtons.map(button => {
        return {
          name: button.name,
          variant: 'outlined',
          relatedEntity: button.relatedEntity
        };
      });
      let selectedIndex = allButtons.findIndex(btn => btn.name === selectedName);
      let currentIndex = currentButtons.findIndex(btn => btn.name === selectedName);
      let isAlreadySelected;

      if (state.runSelected) {
        isAlreadySelected = false;
      } else {
        isAlreadySelected = currentButtons[currentIndex].variant === 'contained';
      }

      if (selectedIndex > -1) {
        allButtons[selectedIndex].variant = isAlreadySelected ? 'outlined' : 'contained';
      }

      state.buttonsNamesArray = allButtons;
      state.selectedDataType = !isAlreadySelected ? selectedName : '';
      state.isEntityChanged = currentButtons[currentIndex].variant !== allButtons[selectedIndex].variant;
    },
    pushTableData: (state, action) => {
      state.relationTableData = { ...state.relationTableData,
        ...action.payload
      };
    },
    pushRunUrl: (state, action) => {
      state.relationUrl = action.payload;
    },
    pushRequestBody: (state, action) => {
      state.relRequestBody = action.payload;
    },
    pushEnableClearAll: (state, action) => {
      state.enableClearAll = action.payload;
    },
    pushgetApiResponse: (state, action) => {
      state[action.payload.type] = action.payload.data;
      state.errorMessage = '';
    },
    pushPostApiResponse: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    pushPutApiResponse: (state, action) => {
      state[action.payload.type] = action.payload.data;
    },
    showDialogWin: (state, action) => {
      state.showDialogWin = action.payload;
    },
    showConfirmationWin: (state, action) => {
      state.showConfirmationWin = action.payload;
    },
    IsdownloadCSV: (state, action) => {
      state.downloadCSVResults = action.payload;
    },
    showSnackEnable: (state, action) => {
      state.snackEnable = action.payload;
    },
    pushIsSaveDisabled: (state, action) => {
      state.isSaveDisabled = action.payload;
    },
    pushQueryRelatedEntity: (state, action) => {
      state.queryRelatedEntity = action.payload;
    },
    pushRunSelected: (state, action) => {
      state.runSelected = action.payload;
    },
    showTostLoader: (state, action) => {
      state.showSnackLoader = action.payload;
    },
    showLoader: (state, action) => {
      state.isLoader = action.payload;
    },
    pushDeleteSelectedItem: (state, action) => {
      if (action.payload.data && Object.entries(action.payload.data).length != 0) {
        let newQuerySet = current(state.getQuery[0].data).filter(eachQuery => eachQuery.queryid !== action.payload);
        state.getQuery[0].data = newQuerySet;
        state.getQuery[0].headers.totalcount = action.payload.count - 1;
      }

      state[action.payload.type] = action.payload.data;
    },
    pushBritSaveBtn: (state, action) => {
      state.isBritSave = action.payload;
    },
    resetCustomQueryHeader: state => {
      state.buttonsNamesArray = [{
        name: 'Users',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Groups',
          isSelected: false
        }, {
          name: 'Roles',
          isSelected: false
        }, {
          name: 'Permissions',
          isSelected: false
        }, {
          name: 'Resources',
          isSelected: false
        }]
      }, {
        name: 'User Accounts',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Groups',
          isSelected: false
        }, {
          name: 'Roles',
          isSelected: false
        }, {
          name: 'Permissions',
          isSelected: false
        }, {
          name: 'Resources',
          isSelected: false
        }]
      }, {
        name: 'Groups',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Users',
          isSelected: false,
          disabledIfSelected: 'User Accounts'
        }, {
          name: 'User Accounts',
          isSelected: false,
          disabledIfSelected: 'Users'
        }, {
          name: 'Permissions',
          isSelected: false
        }, {
          name: 'Resources',
          isSelected: false
        }]
      }, {
        name: 'Roles',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Users',
          isSelected: false,
          disabledIfSelected: 'User Accounts'
        }, {
          name: 'User Accounts',
          isSelected: false,
          disabledIfSelected: 'Users'
        }, {
          name: 'Permissions',
          isSelected: false
        }, {
          name: 'Resources',
          isSelected: false
        }]
      }, {
        name: 'Permissions',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Users',
          isSelected: false,
          disabledIfSelected: 'User Accounts'
        }, {
          name: 'User Accounts',
          isSelected: false,
          disabledIfSelected: 'Users'
        }, {
          name: 'Groups',
          isSelected: false
        }, {
          name: 'Roles',
          isSelected: false
        }, {
          name: 'Resources',
          isSelected: false
        }]
      }, {
        name: 'Resources',
        variant: 'outlined',
        relatedEntity: [{
          name: 'Users',
          isSelected: false,
          disabledIfSelected: 'User Accounts'
        }, {
          name: 'User Accounts',
          isSelected: false,
          disabledIfSelected: 'Users'
        }, {
          name: 'Groups',
          isSelected: false
        }, {
          name: 'Roles',
          isSelected: false
        }, {
          name: 'Permissions',
          isSelected: false
        }]
      }];
      state.isSaveDisabled = true;
      state.selectedDataType = '', state.enableCriteria = false, state.apiResponse = [], state.showRelatedData = false, state.enableClearAll = false, state.relatedData = [], state.relatedDataButton = [], state.hideCard = false, state.apiResponseData = [], state.showDialogWin = false, state.downloadCSVResults = false, state.relationTableData = {
        data: [],
        totalCount: 0,
        totalPages: 0
      }, state.snackEnable = false, state.isSaveDisabled = true, state.queryRelatedEntity = [], state.runSelected = false, state.buttonName = '', state.showPath = false, state.showSnackLoader = false, state.isLoader = false, state.showConfirmationWin = false, state.isNavigating = false, state.isSaveAsPopUp = false, state.isBritSave = false;
    },
    setIsEntityChanged: (state, action) => {
      state.isEntityChanged = action.payload;
    },
    setIsRelatedEntityChanged: (state, action) => {
      state.isRelatedEntityChanged = action.payload;
    }
  }
});
export const {
  pushPostApiResponse,
  pushgetApiResponse,
  pushHideCard,
  selectedRelatedDataButton,
  selectedRelatedEntity,
  selectButton,
  pushAddCriteria,
  pushTableData,
  pushRunUrl,
  getApiResponse,
  pushShowRelatedDta,
  pushIsNavigating,
  pushEnableClearAll,
  pushRequestBody,
  showDialogWin,
  IsdownloadCSV,
  showConfirmationWin,
  showSnackEnable,
  pushIsSaveDisabled,
  pushQueryRelatedEntity,
  pushRunSelected,
  pushDeleteSelectedItem,
  pushPutApiResponse,
  showContextualPath,
  showTostLoader,
  showLoader,
  pushIsSaveAsPopUp,
  pushBritSaveBtn,
  resetCustomQueryHeader,
  setIsEntityChanged,
  setIsRelatedEntityChanged
} = customQueryHeader.actions;
export default customQueryHeader.reducer;